<app-dialogue-box [isDialogOpen]="isDeleteDialogOpen" [title]="dialogTexts.DELETE_SECTION.TITLE"
    [message]="dialogTexts.DELETE_SECTION.MESSAGE" [confirmButtonText]="dialogTexts.DELETE_SECTION.CONFIRM"
    (onClose)="closeDeleteDialog()" (onConfirm)="deleteSection()">
</app-dialogue-box>
<app-dialogue-box [isDialogOpen]="isReworkDialogOpen" [title]="dialogTexts.REWORK_SECTION.TITLE"
    [message]="dialogTexts.REWORK_SECTION.MESSAGE" [confirmButtonText]="dialogTexts.REWORK_SECTION.CONFIRM"
    (onClose)="closeReworkDialog()" (onConfirm)="sendToAgentForRework()">
</app-dialogue-box>
<app-dialogue-box [isDialogOpen]="isReportStatusDialogOpen" [title]="dialogTexts.REPORT_STATUS.TITLE"
    [message]="reportStatusDialogMessage" (onClose)="closeReportStatusDialog()"
    [closeButtonText]="dialogTexts.REPORT_STATUS.CLOSE" [confirmButtonText]="reportStatusDialogButtonText"
    (onConfirm)="handleReportConfirm(reportId)">
</app-dialogue-box>
<app-dialogue-box [isDialogOpen]="isDeleteCommentDialogOpen" [title]="dialogTexts.DELETE_COMMENT.TITLE"
    [message]="dialogTexts.DELETE_COMMENT.MESSAGE" [confirmButtonText]="dialogTexts.DELETE_COMMENT.CONFIRM"
    (onClose)="closeDeleteCommentDialog()" (onConfirm)="deleteSectionComment()">
</app-dialogue-box>
<div class="report-container">
    <app-loader *ngIf="isLoading"></app-loader>
    <div>
        <div class="report-top">
            <div class="report-header">
                <h2 class="report-id-h2">{{ labels.REPORT_SECTIONS.REPORT_ID }}{{ reportId }}</h2>
                <div class="ai-note-tablet">
                    {{ labels.REPORT_SECTIONS.NOTE }}
                </div>
                <p>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.CLIENT_NAME }}</span> <span
                        class="report-header-text">{{
                        clientName }} &nbsp;&nbsp;</span>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.LOCATION_NAME }}</span><span
                        class="report-header-text">{{
                        locationName }} &nbsp;&nbsp;</span>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.REFERRENCES }}: </span> <span
                        class="view-link report-header-text" (click)="openReferrenceDialog()">View</span>
                </p>
            </div>
            <div class="report-data">
                <div class="custom-stepper">
                    <div class="step" [class.active]="step() === 1" [class.done]="step() !== 1">
                        <div class="circle"><mat-icon>check</mat-icon></div>
                        <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="step() === 1 || 2 || 3" [class.done]="step() !== 1 || 2">
                        <div class="circle"><mat-icon>check</mat-icon></div>
                        <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="step() === 3" [class.done]="status === 3">
                        <div class="circle">
                            <mat-icon *ngIf="status === 3; else showStatus" class="initial-center">
                                check
                            </mat-icon>

                            <ng-template #showStatus class="initial-center">
                                <div class="initial-center">3</div>
                            </ng-template>
                        </div>
                        <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="step() === 4">
                        <div class="circle">
                            <div class="initial-center">4</div>
                        </div>
                        <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
                    </div>
                </div>
            </div>
        </div>


        <!-- mat-tree on new row -->
        <div class="report-layout">

            <!-- Tablet Controls -->
            <div class="tablet-controls">
                <button class="tablet-card" (click)="openTOC()" [class.active]="isTOCOverlayOpen"
                    aria-pressed="{{isTOCOverlayOpen}}">
                    <span class="button-text">{{ labels.REPORT_SECTIONS.TABLE_OF_CONTENTS }}</span>
                    <img src="/assets/icons/right-arrow-green.svg" />
                </button>

                <button class="tablet-card" (click)="openScores()" [class.active]="isScoresDialogOpen"
                    aria-pressed="{{isScoresDialogOpen}}" aria-label="Open Average Quality Score">
                    <ng-container *ngIf="overAllQualityScore =='Good'">
                        <img src="/assets/icons/vector_green.svg" alt="Average Quality Score" />
                    </ng-container>
                    <ng-container *ngIf="overAllQualityScore =='Medium'">
                        <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
                    </ng-container>
                    <ng-container *ngIf="overAllQualityScore =='Low'">
                        <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
                    </ng-container>
                    <span class="button-text-score">
                        {{ labels.REPORT_SECTIONS.AVERAGE_QUALITY_SCORE }}
                        <strong class="score-value">{{ overAllQualityScore }}</strong>
                    </span>
                    <img src="/assets/icons/right-arrow-green.svg" />
                </button>
            </div>

            <div class="toc-panel">
                <app-report-outline [dataSource]="dataSource" [treeControl]="treeControl" [hasChild]="hasChild"
                    [isTreeCollapsed]="isTreeCollapsed" [scrollTo]="scrollTo.bind(this)">
                </app-report-outline>
            </div>

            <!-- Sections -->
            <div class="section-layout">
                <div class="section-scroll">
                    <div class="hearder-part">
                        <h2>{{reportName}}</h2>
                        <button type="button" class="aecom_btn" (click)="openDialog()"
                            [disabled]="(status === 3 && isJuniorScientist && !isSeniorScientist)">
                            {{ labels.REPORT_SECTIONS.BUTTON.ADD_SECTION }}
                        </button>
                    </div>
                    <ng-container *ngFor="let section of sectionsData; let i = index">
                        <div class="section-check">
                            <mat-checkbox [checked]="isSectionChecked(section.id)"
                                (change)="onSectionCheckboxChange(section, $event.checked)"
                                [disabled]="section.showBotProgress || status === 4 || (status === 3 && isJuniorScientist && !isSeniorScientist)"></mat-checkbox>
                            <img *ngIf="status === 5" src="/assets/icons/lock.svg" alt="Locked" class="lock-icon" />
                            <div class="section-container" [id]="'sectionContainer-' + section.id">
                                <mat-card class="section-card">
                                    <!-- Section Header -->
                                    <div class="section-header">
                                        <ng-container *ngIf="!section.isEditing; else editHeader">
                                            <span class="section-title">
                                                {{ section.sectionNumber }} {{ section.name }}
                                            </span>
                                        </ng-container>

                                        <ng-template #editHeader>
                                            <input [(ngModel)]="section.sectionNumber"
                                                class="section-title-input-section-id-input"
                                                [attr.size]="(section.sectionNumber.length || 1) + 1" readonly />
                                            <input [(ngModel)]="section.name" class="section-title-input"
                                                placeholder="Section Title" />
                                        </ng-template>

                                        <div class="section-actions">
                                            <button mat-icon-button *ngIf="!section.isEditing"
                                                (click)="editSection(section)"
                                                [disabled]="status === 4 || section.showBotProgress || (status === 3 && isJuniorScientist && !isSeniorScientist)">
                                                <img src="/assets/icons/edit.svg" alt="Close" />
                                            </button>
                                            <button mat-icon-button *ngIf="section.isEditing"
                                                (click)="cancelEdit(section)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            <button mat-icon-button *ngIf="section.isEditing"
                                                (click)="saveSection(section)"
                                                [disabled]="status === 4 || section.showBotProgress || (status === 3 && isJuniorScientist && !isSeniorScientist)">
                                                <img src="/assets/icons/save_section.svg" alt="Close" />
                                            </button>

                                            <button mat-icon-button
                                                (click)="openNotesPopup(section.sectionNumber,section.id)"
                                                [disabled]="status === 4 || section.showBotProgress || (status === 3 && isJuniorScientist && !isSeniorScientist)">
                                                <img src="/assets/icons/note.svg" alt="Close" />
                                            </button>
                                            <button mat-icon-button color="warn" (click)="openDeleteDialog(section)"
                                                [disabled]="status === 4 || section.showBotProgress || (status === 3 && isJuniorScientist && !isSeniorScientist)">
                                                <img src="/assets/icons/delete.svg" alt="Close" />
                                            </button>
                                        </div>
                                    </div>

                                    <div class="section-content">
                                        <ng-container *ngIf="!section.isEditing; else editContent">
                                            <div [innerHTML]="section.content"></div>
                                        </ng-container>
                                        <ng-template #editContent>
                                            <div class="editor-wrapper">
                                                <angular-tiptap-editor class="custom-editor" [content]="section.content"
                                                    [showBubbleMenu]="false" [showImageBubbleMenu]="false"
                                                    [showToolbar]="true" [enableSlashCommands]="false"
                                                    (contentChange)="section.content = $event">
                                                </angular-tiptap-editor>
                                            </div>
                                        </ng-template>
                                    </div>

                                </mat-card>
                            </div>
                        </div>


                    </ng-container>
                </div>

            </div>

            <div class="score-panel">
                <app-report-scores [showScoreBoard]="showScoreBoard" [overAllQualityScore]="overAllQualityScore"
                    [qualityScore]="qualityScore">
                </app-report-scores>
            </div>
        </div>

        <div class="page-action">
            <div class="ai-note">
                {{ labels.REPORT_SECTIONS.NOTE }}
            </div>
            <button type="button" class="action-buttons aecom_btn" (click)="redirectTohome()">{{ labels.COMMON.CLOSE
                }}</button>

            <button type="button" class="action-buttons aecom_btn--solid" (click)="checkSectionSelctionStatus()"
                [disabled]="sectionsData.length==0 || (status === 3 && isJuniorScientist && !isSeniorScientist)">{{
                labels.REPORT_SECTIONS.BUTTON.AGENT_REWORK }}</button>

            @if(isSeniorScientist){
            <button type="button" class="action-buttons aecom_btn--solid"
                (click)="sendForApproval(reportStatusCodes.Generated)">{{
                labels.REPORT_SECTIONS.BUTTON.SEND_FOR_REVISION }}</button>
            <button type="button" class="action-buttons aecom_btn--solid"
                (click)="sendForApproval(reportStatusCodes.Approved)" [disabled]="sectionsData.length==0">{{
                labels.REPORT_SECTIONS.BUTTON.APPROVE_REPORT }}</button>
            } @else if(isJuniorScientist && !isSeniorScientist){
            <button type="button" class="action-buttons aecom_btn--solid" (click)="openApprovalDialog()"
                [disabled]="sectionsData.length==0">{{
                labels.REPORT_SECTIONS.BUTTON.SUBMIT_FOR_APPROVAL }} </button>
            }
        </div>

    </div>
    <div class="notes-popup" *ngIf="notesStatus" [class.closing]="notesClosing">
        <div class="popup-header">
            <h1>{{ labels.REPORT_SECTIONS.COMMENT }} {{ reportId }}</h1>
            <mat-icon class="close-icon" (click)="closeNotesPopup()">close</mat-icon>
        </div>
        <div class="popup-body">

            <div class="add-notes">
                <div class="notes-box">
                    <span class="note-initials">
                        <div class="initial-center">{{ initials }}</div>
                    </span>
                    <textarea placeholder="{{ labels.REPORT_SECTIONS.ENTER_COMMENT }}" rows="7"
                        [(ngModel)]="newComment"></textarea>
                </div>

                <div class="notes-action">
                    <button class="add-note-button aecom_btn" (click)="clearComment()">{{
                        labels.REPORT_SECTIONS.COMMENT_CLEAR }}</button>
                    <button class="add-note-button aecom_btn--solid" (click)="postComment()">{{
                        labels.REPORT_SECTIONS.COMMENT_POST }}</button>
                </div>
            </div>

            <div class="notes-list">
                @for (note of notes; track note.id) {
                <div class="note-item">
                    <div class="note-header">
                        <div class="initial-name">
                            <span class="note-initials" [style.backgroundColor]="getUserColor(note.displayName)">
                                <div class="initial-center">{{ getInitials(note.displayName) }}</div>
                            </span>
                            <div class="note-info">
                                <p class="note-name">{{ note.displayName }} <button mat-icon-button color="warn"
                                        class="note-delete-btn"
                                        (click)="openDeleteDialogForComment(note.sectionId, note.commentId)"
                                        [disabled]="note.updatedBy !== currentUserId">
                                        <img src="/assets/icons/delete.svg" alt="Close" />
                                    </button></p>
                                <p class="note-section"> {{ (note.sectionNumber && note.sectionNumber !== '0.0') ?
                                    note.sectionNumber : '' }}
                                    {{ note.sectionTitle || '' }}</p>
                            </div>
                        </div>
                        <p class="note-timestamp">
                            {{ note.updatedDate | date:"dd-MM-yyyy '|' hh:mm a" }}
                        </p>

                    </div>
                    <p class="note-content">{{ note.userComment }}</p>
                </div>
                }
            </div>
        </div>
        <div class="popup-footer">
            <button class="add-note-button aecom_btn" (click)="closeNotesPopup()">{{ labels.COMMON.CLOSE }}</button>
        </div>
    </div>
</div>

<!-- Direct TOC Fullscreen Overlay (Tablet) -->
<div class="toc-backdrop-overlay" *ngIf="isTOCOverlayOpen" (click)="closeTOCOverlay()">
    <app-report-outline [dataSource]="dataSource" [treeControl]="treeControl" [hasChild]="hasChild"
        [isTreeCollapsed]="false" [scrollTo]="scrollTo.bind(this)">
    </app-report-outline>
</div>
<div class="toc-backdrop-overlay" *ngIf="isScoresDialogOpen" (click)="closeScores()">
    <app-report-scores [showScoreBoard]="showScoreBoard" [overAllQualityScore]="overAllQualityScore"
        [qualityScore]="qualityScore">
    </app-report-scores>
</div>

<div class="dialog-overlay" *ngIf="isDialogOpen || isClosing" [ngClass]="{ 'closing': isClosing }">
    <div class="dialog-box">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ labels.REPORT_SECTIONS.BUTTON.ADD_SECTION }}</h2>
            <button class="close-btn" aria-label="Close" (click)="closeDialog()">&times;</button>
        </div>
        <br>
        <div class="dialog-content">
            <div class="add-Section-form-container">
                <div class="dialogue-container">
                    <div>
                        <label for="selectSection">{{ labels.REPORT_SECTIONS.SELECT_POSTION }}</label>
                        <app-searchable-dropdown [(ngModel)]="selectedSectionId" [items]="sectionNumberList"
                            bindLabel="displayText" bindValue="id" placeholder="Select Position">
                        </app-searchable-dropdown>
                    </div>
                    <br>
                    <div>
                        <label for="sectionNumber">{{ labels.REPORT_SECTIONS.SECTION_NUMBER }}</label>
                        <input type="text" id="sectionNumber" appBlockSpecialChars [(ngModel)]="newSectionNumber"
                            placeholder="Enter Section Number">
                    </div>
                    <br>
                    <div>
                        <label for="sectionTitle">{{ labels.REPORT_SECTIONS.SECTION_TITLE }}</label>
                        <input type="text" id="sectionTitle" [(ngModel)]="newSectionTitle"
                            placeholder="Enter Section Title">
                    </div>
                    <br>
                    <div>
                        <label for="selectSection">{{ labels.REPORT_SECTIONS.SECTION_CONTENT }}</label>
                        <angular-tiptap-editor [content]="newSectionContent" [showBubbleMenu]="false"
                            [showImageBubbleMenu]="false" [showToolbar]="true" [enableSlashCommands]="false"
                            (contentChange)="newSectionContent = $event"></angular-tiptap-editor>
                    </div>

                    <div class="checkbox-inline">
                        <span class="checkbox-inline-label">{{ labels.REPORT_SECTIONS.ADD_SUB_SECTION }}</span>
                        <mat-checkbox [(ngModel)]="addAsChild"></mat-checkbox>
                    </div>

                </div>
            </div>

            <div class="dialog-actions">
                <button class="add-note-button aecom_btn" (click)="closeDialog()">{{ labels.COMMON.CANCEL }}</button>
                <button class="add-note-button aecom_btn--solid" (click)="addNewSection()">{{
                    labels.REPORT_SECTIONS.BUTTON.ADD_SECTION }}</button>
            </div>
        </div>

    </div>
</div>


<div class="dialog-overlay" *ngIf="isReferenceDialogOpen || isReferenceClosing"
    [ngClass]="{ 'closing': isReferenceClosing }">
    <div class="dialog-box">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ labels.REPORT_SECTIONS.REFERRENCES }}</h2>
            <button class="close-btn" aria-label="Close" (click)="closeReferrenceDialog()">&times;</button>
        </div>
        <br>
        <div class="dialog-content">
            <p *ngFor="let ref of referenceFiles" class="reference-item">
                {{ ref }}
            </p>

            <div class="dialog-actions">
                <button class="add-note-button aecom_btn" (click)="closeReferrenceDialog()">{{ labels.COMMON.CLOSE
                    }}</button>
            </div>
        </div>

    </div>
</div>

<div class="dialog-overlay" *ngIf="isApprovalDialogOpen || isApprovalDialogClosing"
    [ngClass]="{ 'closing': isApprovalDialogClosing }">
    <div class="site-manager-dialog-box">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ labels.REPORT_SECTIONS.APPROVAL_DIALOG_TITLE }}</h2>
            <button class="close-btn" aria-label="Close"
                (click)="closeApprovalDialog(); showSuggestions = false">&times;</button>
        </div>
        <br>
        <div class="dialog-content">
            <div class="site-manager-select">
                <label for="selectSection">{{ labels.REPORT_SECTIONS.SElECT_SITE_MANAGER }}</label>
                <div class="search-container">
                    <ng-container *ngIf="!selectedReviewer; else selectedReviewerDisplay">
                        <input type="text" class="search-input" placeholder="Search by name or email..."
                            [(ngModel)]="searchText" (input)="onSearch()" (focus)="showSuggestions = true; onSearch()"
                            (click)="showSuggestions = true; onSearch()" (blur)="onSearchBlur()" autocomplete="off" />

                        <img class="search-icon" src="/assets/icons/search.svg" alt="Close" />
                        <!-- Suggestions -->
                        <div class="suggestions-panel" *ngIf="showSuggestions && filteredReviewers.length">
                            <div class="suggestions-scroll">
                                <div class="suggestion-item" *ngFor="let reviewer of filteredReviewers"
                                    (mousedown)="$event.preventDefault(); selectReviewer(reviewer)">
                                    <div class="name">{{ reviewer.displayName }}</div>
                                    <div class="email">{{ reviewer.email }}</div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #selectedReviewerDisplay>
                        <div class="selected-reviewer">
                            <div class="reviewer-chip">
                                <span class="selected-name">{{ selectedReviewer?.displayName }}</span>
                                <span class="selected-email">{{ selectedReviewer?.email }}</span>
                            </div>
                        </div>
                        <img class="search-icon" src="/assets/icons/close.svg" alt="Close"
                            (click)="clearSelectedReviewer()" />
                    </ng-template>
                </div>
            </div>

            <div class="dialog-actions">
                <button class="add-note-button aecom_btn" (click)="closeApprovalDialog(); showSuggestions = false">{{
                    labels.COMMON.CLOSE}}</button>
                <button type="button" class="action-buttons aecom_btn--solid" (click)="addReviewerForApproval()"
                    [disabled]="sectionsData.length==0">{{
                    labels.REPORT_SECTIONS.BUTTON.ASSIGN_FOR_APPROVAl }} </button>
            </div>
        </div>

    </div>
</div>